import { shallowEqual, useSelector } from "react-redux";

export default function GetUserRole(value) {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const index = user && user?.userRole?.includes(value);
  return index;
}
